import { Flex, FilesList, SidePanel, UploadArea } from "@wayflyer/flyui";
import type { UseUploadManagerReturn } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UPLOAD_STATEMENTS_SIZE_LIMIT_MB } from "../../../../components/constants";
import type { BankStatementUpload } from "../../hooks/use-bank-accounts-upload-manager";
import { MESSAGES } from "../message-definitions";

type UploadStatementsPanelProps = {
  isOpen: boolean;
  onClose: () => void;
} & Pick<
  UseUploadManagerReturn<BankStatementUpload>,
  "uploadsState" | "onFilesAdded" | "onFileRemoved" | "onFileRetry"
>;

export const UploadStatementsPanel = ({
  isOpen,
  onClose,
  uploadsState,
  onFilesAdded,
  onFileRemoved,
  onFileRetry,
}: UploadStatementsPanelProps) => {
  const intl = useIntl();

  return (
    <SidePanel
      open={isOpen}
      isModal={false}
      onClose={onClose}
      closeOnClickElseWhere={false}
      title={intl.formatMessage(MESSAGES.uploadStatementsPanelTitle)}
      variant="md"
      primaryAction={{
        content: intl.formatMessage(MESSAGES.doneUploadingAction),
        onAction: onClose,
      }}
    >
      <Flex direction="column" gap="4">
        <UploadArea
          testId="banking-accounts-upload-statements-area"
          onFilesAdded={onFilesAdded}
          acceptedFileTypes={{ "text/csv": [".csv"], "application/pdf": [".pdf"] }}
          sizeLimitMB={UPLOAD_STATEMENTS_SIZE_LIMIT_MB}
          multiple
        />
        {uploadsState.uploads.length > 0 && (
          <FilesList uploadsState={uploadsState} onFileRemoved={onFileRemoved} onFileRetry={onFileRetry} />
        )}
      </Flex>
    </SidePanel>
  );
};
